import Cookies from 'js-cookie';
import { get30DaysFromNow } from '../helpers/date';

export const defaultAvcCookieName = 'em_avc';
/**
 * Tracks page views and updates the specified cookie with the count.
 *
 * @param [cookieName='em_avc'] - The name of the cookie to track page views. Defaults to 'em_avc'.
 * @returns The updated count of page views.
 * In the future if we want different cookies for different service, we can pass different cookieName, but that's highly unlikely.
 */
export function trackAnonymousViewCount(
  cookieName: string = defaultAvcCookieName
): number {
  // Check if tracking is enabled
  const cookieValue = Cookies.get(cookieName);
  const existingCount = cookieValue ? parseInt(cookieValue) : 0;
  const updatedCount = existingCount + 1;

  Cookies.set(cookieName, updatedCount.toString(), {
    expires: get30DaysFromNow(),
    path: '/',
    domain: '.emarketer.com', // so we follow the same pattern as other `em_..` cookies
  });

  return getAnyonomousViewCount(defaultAvcCookieName);
}

/**
 * Gets the count of page views from the specified cookie.
 *
 * @param cookieName - The name of the cookie to retrieve.
 * @returns The value of the specified cookie, or null if the cookie is not found.
 */
export function getAnyonomousViewCount(
  cookieName: string = defaultAvcCookieName
): number {
  const cookieValue = Cookies.get(cookieName);
  return cookieValue ? parseInt(cookieValue) : 0;
}
